import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFPlainText } from "src/components/Shared/NewForms/NFPlainText";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";

export const TransferOfGoodsDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFLookupProduct title={t("Product")} fieldName="productId" modelField={"productModel"} width={400} required />
        <NFPlainText title={t("VendorCode")} fieldName="vendorCode" modelField={"productModel"} width={200} />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={200} required />
        <NFIntInput fieldName={"quantity"} title={t("Quantity")} width={200} required />
      </NFormTable>
    </>
  );
};
